import React from 'react';
import { Text, Divider, Flex, IconButton } from 'pounceV2';

const ViewBucketDataSideSheetTitleV3 = ({
  title,
  onClose,
}: {
  title: string;
  onClose: () => void;
}) => {
  return (
    <>
      <Flex p={3} align="center" justify="space-between">
        <Text>{title}</Text>
        <IconButton icon="close" aria-label="Dismiss Dialog" variant="outline" onClick={onClose} />
      </Flex>
      <Divider mb={0} />
    </>
  );
};

export default ViewBucketDataSideSheetTitleV3;
